import { Link } from "react-router-dom";
import type { WorkItem } from "@/utils/videoUtils";
import { formatViews } from "@/utils/videoUtils";

interface WorkListRowProps {
  work: WorkItem;
}

export default function WorkListRow({ work }: WorkListRowProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors duration-300"
    >
      <div className="w-full sm:w-32 shrink-0 aspect-[2/3] sm:aspect-[2/3] rounded-md overflow-hidden bg-primary-900">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} - 日本伦理剧`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
            {work.title}
          </h3>
          {work.rating !== null && (
            <span className="shrink-0 flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-label bg-accent-500 text-accent-950">
              <i className="ri-star-fill text-[10px]"></i>
              {work.rating.toFixed(1)}
            </span>
          )}
        </div>
        <p className="mt-1 text-xs text-foreground-600 font-label">
          {work.year} · {work.type} · {work.genre} · 导演 {work.director}
        </p>
        <p className="mt-2 text-sm text-foreground-700 line-clamp-2">{work.synopsis}</p>
        <div className="mt-auto pt-3 flex items-center justify-between gap-2">
          <div className="flex flex-wrap gap-1.5">
            {work.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded-full text-xs font-label bg-secondary-100 text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>
          <span className="shrink-0 text-xs text-foreground-500 font-label">
            {formatViews(work.views)} 浏览
          </span>
        </div>
      </div>
    </Link>
  );
}